/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from "react";
import {
    OrderStatusCssClasses,
    OrderStatusTitles
} from "../../../../app/modules/Sale/pages/orders-list/OrdersListUIHelpers";
import {Link} from "react-router-dom";
import {getLatestInvoices} from "../../../_helpers/DashboardRequests";

export function LastInvoicesWidget({ className }) {

    const [invoices, setInvoices] = useState([]);

    useEffect(() => {
        getLatestInvoices()
            .then(response => {
                setInvoices(response.data.entities);
            })
    }, []);

    return (
        <>
            <div className={`card card-custom ${className}`}>
                {/* Header */}
                <div className="card-header border-0">
                    <h3 className="card-title font-weight-bolder text-dark">
                        آخرین فاکتور های ثبت شده
                    </h3>

                </div>

                {/* Body */}
                <div className="card-body pt-0">


                    {invoices.map(invoice => (
                        <div className="mb-6">
                            <div className="d-flex align-items-center flex-grow-1">

                                <div className="d-flex flex-wrap align-items-center justify-content-between w-100">
                                    <div className="d-flex flex-column align-items-cente py-2 w-75">
                                        <Link
                                            to={`/accounting/invoices/${invoice.id}`}
                                            className="text-dark-75 font-weight-bold text-hover-primary font-size-lg mb-1"
                                        >
                                            {invoice.branchName}
                                        </Link>

                                        <span className="text-muted font-weight-bold">
                    {new Date(invoice.createDate).toLocaleString("fa-IR")}
                  </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}
